// extracted by mini-css-extract-plugin
export default {"perfilContainer":"Perfil_perfilContainer__y56gv","perfil":"Perfil_perfil__i90N8"};